import { Section, ContentWrapper, TextSide, ImageSide, ActionButton } from "./style";
import woman from "../../../../../components/images/woman.png";

export function CtaSection() {
	return (
		<Section>
			<div className="container">
				<ContentWrapper>
					<ImageSide>
						<img src={woman} alt="Crie sua conta" />
					</ImageSide>
					<TextSide>
						<h2>Pronto para economizar?</h2>
						<p>
							Junte-se a milhares de pessoas que já estão aproveitando os melhores
							descontos e benefícios da sua região. Crie sua conta agora, é grátis!
						</p>
						<ActionButton href="/register">Criar minha conta grátis</ActionButton>
					</TextSide>
				</ContentWrapper>
			</div>
		</Section>
	);
}
